<template>
  <div>
    <div class="container">
      <form v-on:submit.prevent="onSubmit" class="custom-form-elements">
        <div class="input-group input-group-icon">
          <input
            type="email"
            placeholder="Email"
            v-model="form.email"
            required
          />
          <div class="input-icon"><i class="pe-7s-mail"></i></div>
        </div>

        <div class="input-group input-group-icon">
          <input
            type="password"
            placeholder="Password"
            v-model="form.password"
            required
          />
          <div class="input-icon"><i class="pe-7s-key"></i></div>
        </div>

        <div class="clearfix">
          <small
            class="pull-left form-text form-text-error mb-3"
            v-show="loginError.length > 1"
          >
            <span v-html="loginError"></span>
          </small>
        </div>

        <div class="text-center">
          <b-button
            type="submit"
            variant="unstitched"
            size="lg"
            class="mt-2 custom-form-btn"
            >Login</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        email: null,
        password: null
      }
    };
  },

  computed: {
    ...mapGetters(["loginError", "currentUser"])
  },

  methods: {
    ...mapActions(["handleLogin", "handleFbLogin"]),

    onSubmit(evt) {
      evt.preventDefault();

      const payload = this.constructPayload();

      this.handleLogin(payload).then(() => {
        if (this.currentUser) {
          window.analytics.identify(this.currentUser.id, {
            name: this.currentUser.name,
            email: this.form.email,
            username: this.currentUser.username
          });
        }
      });
    },

    constructPayload() {
      return {
        auth: {
          email: this.form.email,
          password: this.form.password
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_custom_form.scss";

.form-text-error {
  color: $alizarin;
}
</style>



// WEBPACK FOOTER //
// src/components/formModal/SignInForm.vue